import React, {useEffect} from 'react';

var popit = false;

const OnCloseWarning = (props) => {

    useEffect(() => {
        window.onbeforeunload = function() { 
             if(popit == true) {
                  popit = false;
                  return "Sind Sie sicher, dass Sie das Formular schließen wollen? Einige Daten sind noch nicht gespeichert!"; 
             }
        }
    }, []);

    return "";
}

export default OnCloseWarning;
